import React from 'react';
import { Link } from 'react-router-dom';
import './Tools.css';

const Tools = () => {
    return (
        <div className="tools-page">
            <h1>Developer Tools</h1>
            <p className="tools-description">
                A collection of useful developer tools to help with your daily tasks.
            </p>

            <div className="tools-grid">
                <Link to="/timezone_converter" className="tool-card-link">
                    <div className="tool-card-detail">
                        <div className="tool-icon">🌍</div>
                        <h2>Timezone Converter</h2>
                        <p>Convert times between different timezones around the world. Perfect for coordinating meetings across different locations.</p>
                        <span className="tool-action">Open Tool →</span>
                    </div>
                </Link>

                <Link to="/json_format" className="tool-card-link">
                    <div className="tool-card-detail">
                        <div className="tool-icon">📝</div>
                        <h2>JSON Format Tool</h2>
                        <p>Format, validate, and beautify JSON data. Helps you quickly understand and debug JSON structures.</p>
                        <span className="tool-action">Open Tool →</span>
                    </div>
                </Link>

                <Link to="/length_converter" className="tool-card-link">
                    <div className="tool-card-detail">
                        <div className="tool-icon">📏</div>
                        <h2>Length Converter</h2>
                        <p>Convert between different length units including meters, feet, inches, and more.</p>
                        <span className="tool-action">Open Tool →</span>
                    </div>
                </Link>
            </div>
        </div>
    );
};

export default Tools;
